module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chaptitle"
  }, [_vm._v("Cast of Characters")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("John J. Malone:")]), _vm._v(" Short and little plump, always disheveled, he does not look like a lawyer but he could get a girl “out of trouble if she’d committed a mass murder in an orphanage, with seventeen policemen for witnesses.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Jake Justus:")]), _vm._v(" He’s been many things but right now he’s the press agent and manager for a band leader.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Helene Brand:")]), _vm._v(" For a Northshore deb, she’s a handful and perfectly capable of holding her own. But what’s her connection to the family of the victim?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Holly Inglehart:")]), _vm._v(" A young redhead, she’s just married a man the victim didn’t approve of. Is that motive enough for murder?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Glen Inglehart:")]), _vm._v(" Her black-haired fraternal twin. He stands to inherit every-thing now but he’s standing by his sister.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dick Dayton:")]), _vm._v(" He’s the band leader and a pretty successful one. He doesn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("want")]), _vm._v(" to believe his bride is guilty.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("O.O. Featherstone:")]), _vm._v(" The victim’s attorney. There was time when he might have married her.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ambrose Parkins:")]), _vm._v(" The butler, he firmly believes in Holly’s innocence. What is it that he knows?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Nellie Parkins:")]), _vm._v(" His wife and the cook. Why is she so scared?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maybelle Parkins:")]), _vm._v(" She’s a bit of a floozie and is keen on Glen.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hyme Mendel:")]), _vm._v(" He’s the District Attorney. He doesn’t much like rich people.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Andy Ahearn:")]), _vm._v(" The sheriff, he suspects Jake and Helene are up to no good.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Jasper Fleck:")]), _vm._v(" The chief of police, he knows they’re up to no good.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Al Hedberg:")]), _vm._v(" The coroner. He just cares about bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Butch:")]), _vm._v(" Helene’s chauffeur. From time to time he “gets in jail for something” but he’s a good man to have around.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lewis Miller:")]), _vm._v(" He’s a dapper little man in a derby hat and a chesterfield overcoat. He’s more important that he looks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dr. Kendall:")]), _vm._v(" He’s known to look the other way when Helene gets into trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mrs. Fraser:")]), _vm._v(" She runs a very nice brothel, has a daughter who is an honor student and likes to knit. Besides every story needs a whore with a heart of gold.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_n"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aunt Alexandria Inglehart:")]), _vm._v(" The victim. Absolutely no one liked her.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6df4900b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/FM01.vue
// module id = 72
// module chunks = 0